import React from "react";
import {Card, CardContent, CardHeader, CircularProgress, makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";
import {theme} from "../../../../shared/theme";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(() => ({
    root: {
        border: "1px solid #efeff5",
        borderRadius: "8px",
        marginBottom: '1.5em',
        height: '100%',
        [theme.breakpoints.up(1200)]: {
            width: '100%'
        }
    },
    cardHeader: {
        backgroundColor: "#efeff5",
        paddingLeft: "1.875em",
    },
    cardHeaderThin: {
        padding: "0.5em 0 0.5em 1.875em"
    }
}));

const GrayHeaderCard = (props) => {
    const classes = useStyles();

    return (
        <Card elevation={props.elevation}
              className={classes.root}>
            <CardHeader className={`${classes.cardHeader} ${props.height === "thin" ? classes.cardHeaderThin : ""}`}
                        title={props.title}/>
            <CardContent>
                {props.loading ? <Box textAlign='center'>
                    <CircularProgress size={32}/>
                </Box> : props.children}
            </CardContent>
        </Card>
    );
};
GrayHeaderCard.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    children: PropTypes.element,
    elevation: PropTypes.number,
    loading: PropTypes.bool
};

GrayHeaderCard.defaultProps = {
    elevation: 2,
    loading: false
}

export default GrayHeaderCard;
